import { dateTimeFormat } from '@/utility/utility_functions'

export default class Service {
  constructor (id, name, shortName, code, created, description, appliedQualifications, availableQualifications, appliable) {
    this.id = id
    this.name = name
    this.shortName = shortName
    this.code = code
    this.created = created
    this.description = description
    this.appliedQualifications = appliedQualifications
    this.availableQualifications = availableQualifications
    this.appliable = appliable
  }

  get appliedQualificationsStr () {
    return this.appliedQualifications.map(item => item.code).join(', ')
  }

  get availableQualificationsStr () {
    return this.availableQualifications.join(', ')
  }

  get hasNoQualifications () {
    return this.appliedQualifications.length === 0 && this.availableQualifications.length === 0
  }

  static asServices (json) {
    return json.map(service => {
      return Service.asService(service)
    })
  }

  static asService (json) {
    return new Service(
      json.id,
      json.name,
      json.short_name,
      json.code,
      json.created ? dateTimeFormat(json.created) : dateTimeFormat(new Date()),
      json.description ? json.description : '',
      json.applied_codes ? ServiceQualification.asServiceQualifications(json.applied_codes) : [],
      json.available_codes ? json.available_codes : [],
      json.appliable
    )
  }
}

class ServiceQualification {
  constructor (code, applicationDate) {
    this.code = code
    this.applicationDate = applicationDate
  }

  static asServiceQualifications (json) {
    return json.map(item => {
      return ServiceQualification.asServiceQualification(item)
    })
  }

  static asServiceQualification (json) {
    return new ServiceQualification(
      json.code,
      json.application_date
    )
  }
}
